import { FC, useEffect, useState } from 'react';
import { Icon, Icons } from '@silverfort/sf-components';
import { MainReportOption } from './types';
import { Collapse } from '@material-ui/core';
import { useReportsDrawer } from './ReportsDrawerContext';

interface ReportsMenuProps {
    options: Record<string, MainReportOption>;
}

const ReportsMenu: FC<ReportsMenuProps> = ({ options }) => {
    return (
        <div className="flex flex-col p-4 w-50 h-full gap-6 bg-sf-gray-0">
            {Object.values(options).map((item, index) => (
                <ReportsMenuItemsGroup {...item} key={item.id} />
            ))}
        </div>
    );
};

const ReportsMenuItemsGroup: FC<MainReportOption> = ({ id, label, subItems }) => {
    const { selectedReportOption, setSelectedReportOption } = useReportsDrawer();

    const [subItemsVisible, setSubItemsVisible] = useState(false);
    useEffect(() => {
        setSubItemsVisible(!!subItems?.[selectedReportOption]);
    }, [selectedReportOption, subItems]);

    return (
        <div className="flex flex-col gap-1">
            <ReportsMenuItem
                label={label}
                type="main"
                icon={subItemsVisible ? 'ChevronRight' : 'ChevronDown'}
                onClick={() => setSubItemsVisible(!subItemsVisible)}
            />
            <Collapse in={subItemsVisible}>
                <div className="flex flex-col">
                    {Object.values(subItems).map((item, index) => (
                        <ReportsMenuItem
                            key={item.id}
                            label={item.label}
                            type="sub"
                            selected={selectedReportOption === item.id}
                            onClick={() => setSelectedReportOption(item.id)}
                            icon={item.isRecurring ? 'Calendar' : 'Refresh'}
                        />
                    ))}
                </div>
            </Collapse>
        </div>
    );
};

interface ReportMenuItemProps {
    label: string;
    type: 'main' | 'sub';
    icon: string;
    selected?: boolean;
    onClick: () => void;
}

const ReportsMenuItem: FC<ReportMenuItemProps> = ({ label, type, icon, selected, onClick }) => {
    const isMain = type === 'main';
    return (
        <div
            className={`flex items-center font-sf h-8 py-1 cursor-pointer px-2 rounded-lg group
            ${selected ? 'bg-sf-gray-50' : 'bg-sf-gray-0'} ${
                isMain ? ' gap-1 text-sf-gray-400' : 'gap-2 text-sf-gray-800'
            }`}
            onClick={onClick}>
            {!isMain && Icons[icon] && <Icon icon={Icons[icon]} />}
            <span className="text-13 font-medium">{label}</span>
            {isMain && Icons[icon] && <Icon icon={Icons[icon]} className="invisible group-hover:visible" />}
        </div>
    );
};

export default ReportsMenu;
